import React from "react";

const NavigationArrow = ({
  className = "w-[36px] h-[36px] sm:w-[38px] sm:h-[38px] md:w-[42px] md:h-[42px] lg:w-[56px] lg:h-[56px] xl:w-[52px] xl:h-[52px]",
  fill = "#F8F9FA",
  pathFill = "#0A3D5B",
}: {
  className: string;
  fill?: string;
  pathFill?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 38 38"
      fill="none"
      className={className}
    >
      <rect
        x="0.851562"
        y="0.884766"
        width="37.0968"
        height="37.0968"
        rx="18.5484"
        fill={fill}
      />
      <path
        d="M16.4201 25.6007C16.2621 25.4188 16.1734 25.1721 16.1734 24.9149C16.1734 24.6577 16.2621 24.411 16.4201 24.2291L20.5911 19.4273L16.4201 14.6255C16.2666 14.4426 16.1817 14.1975 16.1836 13.9432C16.1855 13.6888 16.2741 13.4455 16.4304 13.2657C16.5866 13.0858 16.7979 12.9838 17.0189 12.9816C17.2398 12.9794 17.4526 13.0771 17.6116 13.2538L22.3783 18.7415C22.5363 18.9234 22.625 19.1701 22.625 19.4273C22.625 19.6845 22.5363 19.9312 22.3783 20.1131L17.6116 25.6007C17.4536 25.7826 17.2393 25.8848 17.0158 25.8848C16.7924 25.8848 16.5781 25.7826 16.4201 25.6007Z"
        fill={pathFill}
      />
    </svg>
  );
};

export default NavigationArrow;
